import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const FishBasedIcon: FunctionComponent<IIconProps> = (props) => {
  const { color } = props;
  return (
    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600" fill={color}>
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html: `.cls-fish-1,.cls-fish-2,.cls-fish-3{fill:none;stroke:${color};stroke-miterlimit:10;}.cls-fish-1,.cls-fish-3{stroke-width:20px;}.cls-fish-2,.cls-fish-3{stroke-linecap:round;}.cls-fish-2{stroke-width:15px;}`,
          }}
        />
      </defs>
      <path
        className="cls-fish-1"
        d="M463.35,160.41c-1.53,29-8,78.54-32.41,122a175.34,175.34,0,0,1-28.74,38.35,292.76,292.76,0,0,1-40.15,34c-30.85,21.34-60,30.53-88.05,32.13a13.31,13.31,0,0,0-12.48,14.76c1.5,13.9.59,30.22-3.13,47.23-6.47,29.62-29.29,51.72-43.57,63-6.7,5.32-15.32,3.43-19.2-4.19-8.26-16.24-19.79-45.84-13.32-75.46,1.16-5.32,2.54-10.46,4.11-15.38a3.16,3.16,0,0,0-4-4c-4.93,1.56-10.06,2.95-15.38,4.11-29.62,6.47-59.22-5.06-75.46-13.32-7.62-3.88-9.51-12.5-4.19-19.2,11.31-14.29,33.41-37.1,63-43.57,17.42-3.81,34.12-4.67,48.24-3a13.29,13.29,0,0,0,14.85-12.36c.24-3.6.58-7.23,1.07-10.87,4.77-36.74,22.22-75.85,63.93-117.56,16-16,34.7-27.87,54-36.67,39.3-18,80.88-23.14,106.43-24.49A22.87,22.87,0,0,1,463.35,160.41Z"
        fill={color}
      />
      <circle cx="378.39" cy="197.13" r="12.39" fill={color} />
      <path
        className="cls-fish-2"
        d="M325.56,245.53c-4.85,4.85-13.38,4.19-19.05-1.48S300.18,229.85,305,225"
        fill={color}
      />
      <path
        className="cls-fish-2"
        d="M290.94,303.43c-4.85,4.85-13.38,4.19-19.05-1.48s-6.33-14.2-1.48-19.05"
        fill={color}
      />
      <path
        className="cls-fish-2"
        d="M342.81,299.43c-4.85,4.85-13.38,4.19-19.05-1.48s-6.33-14.19-1.48-19"
        fill={color}
      />
      <path
        className="cls-fish-3"
        d="M221.29,284.94c-42.76-.44-62.7-27.65-5.39-101.89,29.88-38.69,64.19-32.75,116.58-22.6"
        fill={color}
      />
      <path
        className="cls-fish-3"
        fill={color}
        d="M423,400.36c-13.78,15-36-25.69-52-52,13.06-9,17.56-13.81,31.29-27.53a175.34,175.34,0,0,0,28.74-38.35C440.28,299.61,477.76,340.72,423,400.36Z"
      />
    </svg>
  );
};
